import React, { RefObject, useCallback } from 'react';

import { FocusableHtmlElement } from '../hooks';
import { CurrentSporsmal } from '../reducer/current-steg';
import { CurrentSporsmalAction } from '../reducer/currentSporsmalReducer';
import { updateSporsmalList } from '../reducer/sporsmalsflyt-actions';
import { SporsmalsflytDispatchProvider } from '../reducer/sporsmalsflytDispatchProvider';
import { Sporsmal } from '../sporsmalCard';

interface Props {
    sporsmalflytCollectionId: string;
    sporsmal: CurrentSporsmal;
    showFeilmeldinger: boolean;
    onNext: () => void;
    focusOnMount?: boolean;
    errorRef?: RefObject<FocusableHtmlElement>;
}

export const SporsmalListSporsmal = ({
    sporsmalflytCollectionId,
    sporsmal,
    showFeilmeldinger,
    onNext,
    errorRef,
    focusOnMount = false,
}: Props) => {
    const mapAction = useCallback(
        (action: CurrentSporsmalAction) => updateSporsmalList(sporsmalflytCollectionId, sporsmal.sporsmal.id, action),
        [sporsmal.sporsmal.id, sporsmalflytCollectionId],
    );

    return (
        <SporsmalsflytDispatchProvider mapAction={mapAction}>
            <Sporsmal
                currentSporsmal={sporsmal}
                showFeilmelding={showFeilmeldinger}
                onNext={onNext}
                focusOnMount={focusOnMount}
                prefix={`${sporsmalflytCollectionId}-`}
                errorRef={errorRef}
            />
        </SporsmalsflytDispatchProvider>
    );
};
